import { Component, OnInit, Input, NgZone } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { EnglishLesson } from 'src/app/models/english-lesson';
import { Router, RouterState } from '@angular/router';
import { Translate, getLocalTranslate } from 'src/app/helpers/global-functions'

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  @Input() isHome: boolean = false;

  lessons: EnglishLesson[] = [];

  home: string = 'Home'
  aboutEdu: string = 'About Us'
  profile: string = 'Profile'
  instructor: string = 'Instructor'
  partner: string = 'Partner'
  feedback: string = 'Feedback'
  faq: string = "FAQ's"
  userGuide: string = 'User Guide'
  courses: string = 'Courses'
  englishLesson: string = 'Lessons'
  knowledge: string = 'Knowledge'
  dictionary: string = 'Dictionary'
  contact: string = 'Contact Us'

  pageIndex: number = 0

  constructor(
    private firestore: AngularFirestore,
    private zone: NgZone,
    private router: Router
  ) {

    router.events.subscribe((val) => {
      this.checkActivePage()
    })

  }

  ngOnInit() {

    this.needTranslate()

    this.firestore.collection('english-lessons', ref => ref.where('status', '==', 1)).get().subscribe(queriedItems => {
      var lessons = queriedItems.docs.map(function (doc) {
        var lesson = doc.data() as EnglishLesson
        const id = doc.id
        lesson.id = id
        return lesson
      })
      this.lessons = lessons

    })

  }

  checkActivePage() {

    const state: RouterState = this.router.routerState

    var url = state.snapshot.url

    if (url === '/') {
      this.pageIndex = 0
    } else if (url.includes('other') || url.includes('instructor') || url.includes('partner')) {
      this.pageIndex = 1
    } else if (url.includes('course')) {
      this.pageIndex = 2
    } else if (url.includes('lesson')) {
      this.pageIndex = 3
    } else if (url.includes('knowledge')) {
      this.pageIndex = 4
    } else if (url.includes('contact')) {
      this.pageIndex = 4
    } else {
      this.pageIndex = 6
    }

    console.log(this.pageIndex)
  }



  setClasses() {
    let classes = {
      'navbar-area': true,
      'navbar-style-three': this.isHome
    }
    return classes;
  }

  onRouteToCourses(id: string) {
    this.zone.run(() => {
      this.router.navigate(['lessons/' + id]);
    });
  }

  needTranslate() {
    this.home = getLocalTranslate('home', this.home)
    this.aboutEdu = getLocalTranslate('about-us', this.aboutEdu)
    this.profile = getLocalTranslate('profile', this.profile)
    this.instructor = getLocalTranslate('instructor', this.instructor)
    this.partner = getLocalTranslate('partner', this.partner)
    this.feedback = getLocalTranslate('feedback', this.feedback)
    this.faq = getLocalTranslate('faq', this.faq)
    this.userGuide = getLocalTranslate('user-guide', this.userGuide)
    this.courses = getLocalTranslate('courses', this.courses)
    this.englishLesson = getLocalTranslate('english-lesson', this.englishLesson)
    this.knowledge = getLocalTranslate('knowledge', this.knowledge)
    this.dictionary = getLocalTranslate('dictionary', this.dictionary)
    this.contact = getLocalTranslate('contact-us', this.contact)
  }

}

